
$(function(){
  $('.blu-allimages-product-page-slider .owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    responsiveClass:true,
    items:1,
    dots: true,
    autoHeight:true
  })
  let lastScrollTop = 0;
  $(window).scroll(function() {
     let st = window.pageYOffset || document.documentElement.scrollTop;
     let heightHeader = $("#header").outerHeight();
     console.log(heightHeader);
     if(st > lastScrollTop){
       $("body").addClass("menu-hide");
     }else if(st < lastScrollTop){
       $("body").removeClass("menu-hide");
     }
     lastScrollTop = st <= 0 ? 0 : st;
  });
});